import React from "react";
import { Link } from "react-router-dom";
import ContactCta from "../components/ContactCta";
import EmergencyCta from "../components/EmergencyCta";

function Home() {
	const imageSrc = (path) => process.env.PUBLIC_URL + path;

	return (
		<div>
			<section>
				<div className="flex flex-col md:min-h-[540px] md:flex-row">
					<div className="flex w-full shrink-0 flex-col justify-center bg-[#1645FF] px-8 py-12 md:w-[70%] md:px-16 lg:px-20 xl:px-24">
						<p className="text-xs font-semibold tracking-[0.22em] text-white md:text-sm">
							WELCOME TO MID-STATE
						</p>
						<h2 className="mt-3 font-sans text-4xl font-bold text-white md:text-5xl lg:text-[56px] lg:leading-tight">
							Our Mission
						</h2>
						<div className="mt-4 h-[3px] w-14 bg-white"></div>
						<p className="mt-6 text-[15px] leading-relaxed text-white md:text-base lg:text-lg">
							Mid-State Ag Supply LLC is dedicated to improving
							farm productivity and animal comfort through
							expertly designed and installed ventilation systems,
							barn curtains, and fans. Our commitment to quality
							and service excellence ensures a superior
							environment for livestock and streamlined operations
							for farmers.
						</p>
						<Link
							to="/products"
							className="mt-8 inline-flex w-fit rounded-md bg-[#2B66E3] px-6 py-3 text-sm font-semibold text-white transition hover:bg-[#3d78f0] md:text-base"
						>
							Explore Product Range
						</Link>
					</div>
					<div className="grid min-h-[280px] w-full min-w-0 grid-cols-2 grid-rows-[1.35fr_1fr] md:min-h-0 md:w-[30%]">
						<img
							className="col-span-2 h-full w-full object-cover"
							src={imageSrc("/images/hero-desktop (1).png")}
							alt="Cows resting in a modern dairy barn"
						/>
						<img
							className="h-full w-full object-cover"
							src={imageSrc("/images/hero-desktop (2).png")}
							alt="Cows feeding along barn stalls"
						/>
						<img
							className="h-full w-full object-cover"
							src={imageSrc("/images/hero-desktop (3).png")}
							alt="Barn ventilation and hoop housing"
						/>
					</div>
				</div>
			</section>

			<section className="bg-[#F3F4F6] px-4 py-8 md:px-8 md:py-12">
				<div className="mx-auto flex max-w-6xl flex-col gap-6">
					<ContactCta />
					<EmergencyCta />
				</div>
			</section>
		</div>
	);
}

export default Home;
